export const isEmailValid = (value: string): boolean =>
	/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)

export const isValidLink = (value: string): boolean =>
	/(?:(?:https?:\/\/)|(?:\.))[^\s]+/i.test(value)
